import { render, staticRenderFns } from "./editorials.vue?vue&type=template&id=4644010e&"
import script from "./editorials.vue?vue&type=script&lang=js&"
export * from "./editorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports